export const SESSION_SECONDS = 120;
export const STARTING_COINS = 100;
export const BOSS_AT_SECOND = 60;
export const MAX_PROJECTILES = 30;
export const FISH_TABLE = {
  small: { hp: 1, reward: 2, speed: 80, width: 42, height: 42, asset: 'fish_small' },
  medium: { hp: 2, reward: 6, speed: 105, width: 58, height: 50, asset: 'fish_small' },
  large: { hp: 4, reward: 20, speed: 50, width: 76, height: 66, asset: 'fish_small' },
  golden: { hp: 1, reward: 50, speed: 95, width: 50, height: 44, asset: 'fish_small' },
  boss: { hp: 10, reward: 200, speed: 45, width: 128, height: 96, asset: 'fish_boss' },
} as const;
export const POWER_LEVELS = {
  1: { cost: 1, damage: 1 },
  2: { cost: 3, damage: 2 },
  3: { cost: 5, damage: 4 },
} as const;